<div
    id="userwayAccessibilityIcon"
    class="a11y-icon">
    <img
        [ngSrc]="iconSrc"
        fill />
</div>
